import React, { useState, useEffect, useRef } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { Button } from 'swag-client-common/components/ui/button';
import { LOGO_INPUT_ACCEPT } from 'swag-client-common/utils/constants';
import Loading from 'swag-client-common/components/info/loading';
import Drawer from '../../ui/drawer';
import { LogoItem } from './components/logo-item';
import classes from './company-art-folder-all-logos-popup.scss';
export const CompanyArtFolderAllLogosPopup = ({
  open,
  view,
  isInitialLoading,
  isPartLoading,
  isListEmpty,
  showList,
  logos,
  onClose,
  onSubmitSelectedLogo,
  onDeleteLogo,
  onUploadLogo,
  loadMoreLogos,
  hasMoreLogos,
  updateLogoPagination
}) => {
  const [selectedId, setSelectedId] = useState('');
  const containerListRef = useRef(null);
  const handleItemSelect = logo => {
    setSelectedId(logo._id);
  };
  useEffect(() => {
    if (open && !isInitialLoading && !isPartLoading) {
      updateLogoPagination();
      loadMoreLogos();
    }
  }, [open]);
  const handleSubmitSelectedLogo = () => {
    if (selectedId) {
      const selectedLogo = logos.find(({
        _id
      }) => _id === selectedId);
      if (selectedLogo) {
        onSubmitSelectedLogo(selectedLogo);
      }
    }
  };
  const handleInputChange = event => {
    var _event$target, _event$target$files;
    const file = (_event$target = event.target) === null || _event$target === void 0 ? void 0 : (_event$target$files = _event$target.files) === null || _event$target$files === void 0 ? void 0 : _event$target$files[0];
    if (file && view) {
      onUploadLogo(file, view);
    }
  };
  const handleLoadMoreLogos = () => {
    if (!isInitialLoading && !isPartLoading && hasMoreLogos) {
      loadMoreLogos();
    }
  };
  return /*#__PURE__*/React.createElement(Drawer, {
    prerenderForCrawlers: true,
    dataDrawer: "CompanyArtFolderLogos",
    onClose: onClose,
    headerTitle: "Company Art Folder",
    headerClassName: classes.header,
    bodyClassName: classes.body,
    isLoading: isInitialLoading,
    paperClassName: classes.root,
    open: open
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.containerList,
    ref: containerListRef
  }, isListEmpty && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h5", {
    className: classes.subTitle
  }, "No saved designs!"), /*#__PURE__*/React.createElement("p", {
    className: classes.description
  }, "Once you upload a design from your computer, it will appear in your art folder for next time. Close this popup and upload from your computer.")), showList && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: classes.description
  }, "If you can\u2019t find what you\u2019re looking for, you can select \u201CUpload From Computer\u201D under the \u201CSelect\u201D button at the bottom of this pop up."), /*#__PURE__*/React.createElement("h5", {
    className: classes.subTitle
  }, "Please select artwork:"), /*#__PURE__*/React.createElement(InfiniteScroll, {
    className: classes.list,
    loadMore: handleLoadMoreLogos,
    hasMore: hasMoreLogos,
    useWindow: false,
    initialLoad: false,
    getScrollParent: () => containerListRef.current,
    loader: /*#__PURE__*/React.createElement("div", {
      key: "loader",
      className: classes.partLoading
    }, /*#__PURE__*/React.createElement(Loading, null))
  }, logos.map(logo => /*#__PURE__*/React.createElement(LogoItem, {
    key: logo._id,
    isSelected: selectedId === logo._id,
    logo: logo,
    onClick: handleItemSelect,
    onDelete: onDeleteLogo
  }))))), showList && /*#__PURE__*/React.createElement("div", {
    className: classes.bottomPanel
  }, /*#__PURE__*/React.createElement(Button, {
    dataButton: "Select",
    type: "primary",
    className: classes.selectButton,
    disabled: !selectedId,
    onClick: handleSubmitSelectedLogo
  }, "Select"), /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("div", {
    className: classes.uploadButton
  }, "Upload From Computer"), /*#__PURE__*/React.createElement("input", {
    className: classes.fileInput,
    accept: LOGO_INPUT_ACCEPT,
    type: "file",
    onChange: handleInputChange
  })))));
};